import News from '@/features/news/News';
import { formatIsoDate } from '@/utils/date';

import type { SubscriptionsTrials } from '@/types/mercury-data-types';

const TrialsModal = ({ trials }: { trials: Array<SubscriptionsTrials> }) => {
  const rows = trials.map(
    (t) => `<p><b>${t.name}</b>: Ends on ${formatIsoDate(t.end_at ?? '')}</p>`
  );

  return (
    <News
      expanded
      newsItem={{
        title: 'We got news for you!',
        content: `
          <p>You have been granted access to the following trials:</p>
          ${rows.join('')}

          <p>You can always check which trials you have active on your subscriptions
           page accessible via your profile menu</p>
        `,
      }}
    />
  );
};

export default TrialsModal;
